/**
 * Secondipity Storefront Interactive Scripts — Optimized ES6+ & jQuery Version
 */

/**
 * Shared, page-agnostic helpers other page scripts (collection.js, product.js) hook into.
 */
window.Secondipity = window.Secondipity || {};

/**
 * Smooth-animates native <details>/<summary> open/close via the Web Animations
 * API instead of the browser's instant toggle. Progressive enhancement: if
 * Element.animate is unsupported, native <details> behavior still works.
 * Call once per page for whichever selector groups that page's accordions
 * (e.g. '.filter-group' on collection.html, '.accordion-row' on product pages).
 */
window.Secondipity.initSmoothDetails = function (selector) {
    document.querySelectorAll(selector).forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary || typeof details.animate !== 'function') return;

        let animation = null;
        let isClosing = false;
        let isExpanding = false;
        const duration = 250;
        const easing = 'ease-out';

        summary.addEventListener('click', (e) => {
            e.preventDefault();
            details.style.overflow = 'hidden';

            if (isClosing || !details.open) {
                openDetails();
            } else if (isExpanding || details.open) {
                shrink();
            }
        });

        function shrink() {
            isClosing = true;
            details.classList.remove('is-open');

            const startHeight = `${details.offsetHeight}px`;
            const endHeight = `${summary.offsetHeight}px`;

            if (animation) animation.cancel();
            animation = details.animate({ height: [startHeight, endHeight] }, { duration, easing });
            animation.onfinish = () => onAnimationFinish(false);
            animation.oncancel = () => { isClosing = false; };
        }

        function openDetails() {
            details.style.height = `${details.offsetHeight}px`;
            details.open = true;
            details.classList.add('is-open');
            window.requestAnimationFrame(() => expand());
        }

        function expand() {
            isExpanding = true;
            const body = details.querySelector('.filter-group-body, .accordion-row-body');
            const startHeight = `${details.offsetHeight}px`;
            const endHeight = `${summary.offsetHeight + (body ? body.offsetHeight : 0)}px`;

            if (animation) animation.cancel();
            animation = details.animate({ height: [startHeight, endHeight] }, { duration, easing });
            animation.onfinish = () => onAnimationFinish(true);
            animation.oncancel = () => { isExpanding = false; };
        }

        function onAnimationFinish(open) {
            details.open = open;
            animation = null;
            isClosing = false;
            isExpanding = false;
            details.style.height = '';
            details.style.overflow = '';
        }
    });
};

$(function () {
    'use strict';

    // -------------------------------------------------------------------------
    // 1. Section-owned widgets
    // Hero banners, product carousels (featured promo, related products,
    // recently viewed, flash deals), category bubbles and the flash-sale
    // countdown initialize themselves inside their own section files, scoped
    // to that section instance, so they work on any page and when added in
    // the theme editor. Don't init them here too: a second `new Swiper` on
    // the same element overrides the section's config and duplicates
    // navigation handlers.
    // -------------------------------------------------------------------------

    // -------------------------------------------------------------------------
    // 1b. Announcement Bar Carousel — rotates through multiple messages
    // (sections/announcement-bar.liquid blocks), sliding the current one out
    // to the left while the next slides in from the right, on a timer.
    // No-ops if there's only one message (or none) configured.
    // -------------------------------------------------------------------------
    document.querySelectorAll('.announcement-slider').forEach(function (slider) {
        const slides = slider.querySelectorAll('.announcement-slide');
        if (slides.length < 2) return;

        const TRANSITION_MS = 500;
        let current = 0;

        setInterval(function () {
            const outgoing = slides[current];
            current = (current + 1) % slides.length;
            const incoming = slides[current];

            outgoing.classList.remove('is-visible');
            outgoing.classList.add('is-prev');
            incoming.classList.add('is-visible');

            // Once the outgoing slide has finished sliding off to the left,
            // snap it back to its default off-screen-right position
            // (no-transition, so the reset itself isn't animated) so it's
            // ready to slide in from the right again on its next turn.
            setTimeout(function () {
                outgoing.classList.add('no-transition');
                outgoing.classList.remove('is-prev');
                void outgoing.offsetWidth; // force reflow to apply the position change before re-enabling transitions
                outgoing.classList.remove('no-transition');
            }, TRANSITION_MS);
        }, 4000);
    });

    // -------------------------------------------------------------------------
    // 2. Flash Sale Copy Code Button
    // -------------------------------------------------------------------------
    $(document).on('click', '.flash-copy-btn', function () {
        const $btn = $(this);
        const code = $btn.data('copyCode');
        if (!code) return;

        const originalText = $btn.text();

        const onSuccess = () => {
            $btn.text('✓ Copied!');
            setTimeout(() => $btn.text(originalText), 2000);
        };

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(code).then(onSuccess).catch(() => fallbackCopy(code, onSuccess));
        } else {
            fallbackCopy(code, onSuccess);
        }
    });

    function fallbackCopy(text, callback) {
        const $temp = $('<textarea>').val(text).appendTo('body').select();
        try {
            document.execCommand('copy');
            callback();
        } catch (_) { }
        $temp.remove();
    }

    // -------------------------------------------------------------------------
    // 5. Color Swatches Click Interaction
    // -------------------------------------------------------------------------
    $('.color-swatches').on('click', '.swatch-item', function (e) {
        e.stopPropagation();
        $(this).siblings().removeClass('active').end().addClass('active');
    });

    // -------------------------------------------------------------------------
    // 6. Add to Cart Simulation & Toast Notification
    // -------------------------------------------------------------------------
    let cartCount = 0;
    let cartTotal = 0.00;
    const $toast = $('#toast-notification');
    const $toastMsg = $('#toast-message');
    let toastTimeout = null;

    const showToast = (message) => {
        if (!$toast.length) return;
        if ($toastMsg.length) $toastMsg.text(message);

        $toast.addClass('show');
        clearTimeout(toastTimeout);
        toastTimeout = setTimeout(() => $toast.removeClass('show'), 3000);
    };

    // Add to cart handled by cart.js


    // -------------------------------------------------------------------------
    // 7. Wishlist Heart Toggle
    // -------------------------------------------------------------------------
    // Saved items are handled by wishlist.js, including persistence and removal.

    // -------------------------------------------------------------------------
    // 8. Nav Panels & Mega Menu Controller
    // -------------------------------------------------------------------------
    let closeMegaMenuFn = null;
    let closeNavPanelsFn = null;
    let closeAllDeptFn = null;

    // On mobile, #siteNavBar IS the fully expanded hamburger drawer (every
    // link stacked, plus the Flash Deals button), so its own bottom edge can
    // sit anywhere down the page depending on how much is open — using it to
    // position a panel would push the panel below the whole drawer instead
    // of overlaying it. Below this breakpoint every panel positions itself
    // against the header's bottom edge only, same as the All Departments
    // panel already did; above it, desktop keeps using the nav bar (a slim
    // strip sitting right under the header) so flyouts still line up with it
    // instead of overlapping it.
    const mobileNavQuery = window.matchMedia('(max-width: 768px)');

    // --- Nav Panels (Full Width Dropdowns) ---
    const $navBar = $('#siteNavBar');
    const $navPanelCont = $('#navPanelContainer');
    const $navPanelOverlay = $('#navPanelOverlay');
    // #categoriesNavItem keeps the .has-dropdown class (it still drives the
    // shared arrow-rotate CSS) but is excluded here — it's wired to the
    // mega-menu system below instead, and including it in both would
    // double-bind conflicting click handlers to the same link.
    const $navItems = $('.nav-item.has-dropdown').not('#categoriesNavItem');
    const $navPanels = $('.nav-panel');
    const $navPanelBack = $('#navPanelBack');
    const $navPanelBackLabel = $('#navPanelBackLabel');

    if ($navBar.length && $navPanelCont.length && $navPanelOverlay.length) {
        const positionNavPanel = ($activeItem) => {
            if (!$navBar.length) return;
            const $header = $('.site-header');
            const topPos = (mobileNavQuery.matches && $header.length)
                ? $header[0].getBoundingClientRect().bottom
                : $navBar[0].getBoundingClientRect().bottom;
            $navPanelCont.css('top', topPos + 'px');
            $navPanelOverlay.css('top', topPos + 'px');

            if (!mobileNavQuery.matches && $activeItem && $activeItem.length) {
                const itemRect = $activeItem[0].getBoundingClientRect();
                const $targetPanel = $navPanels.filter('.is-active');
                const $card = $targetPanel.find('.nav-panel__card');
                const $container = $targetPanel.find('.container');

                if ($card.length && $container.length) {
                    const containerRect = $container[0].getBoundingClientRect();
                    const paddingLeft = parseFloat($container.css('padding-left')) || 0;
                    const paddingRight = parseFloat($container.css('padding-right')) || 0;

                    const contentLeft = containerRect.left + paddingLeft;
                    const containerInnerWidth = containerRect.width - paddingLeft - paddingRight;
                    const cardWidth = $card.outerWidth() || 890;

                    const idealLeft = itemRect.left - contentLeft;
                    const maxLeft = Math.max(0, containerInnerWidth - cardWidth);
                    const finalLeft = Math.max(0, Math.min(idealLeft, maxLeft));

                    $card.css('margin-left', finalLeft + 'px');
                }
            }
        };

        const showNavPanel = (panelId, $activeItem) => {
            if (typeof closeMegaMenuFn === 'function') closeMegaMenuFn();
            if (typeof closeAllDeptFn === 'function') closeAllDeptFn();

            $navItems.removeClass('is-active').find('.nav-link').attr('aria-expanded', 'false');
            if ($activeItem) {
                $activeItem.addClass('is-active').find('.nav-link').attr('aria-expanded', 'true');
            }

            $navPanels.removeClass('is-active');
            const $targetPanel = $('#' + panelId).addClass('is-active');

            positionNavPanel($activeItem);

            $navPanelCont.addClass('is-visible').attr('aria-hidden', 'false');
            $navPanelOverlay.addClass('is-visible');
            // Mobile-only back bar (see the CSS gated to that breakpoint) —
            // full-screen there, so it needs its own way back to the drawer
            // instead of relying on an overlay click/outside-tap.
            $navPanelBackLabel.text($targetPanel.attr('aria-label') || '');
        };

        const closeNavPanelImmediately = () => {
            $navPanelCont.removeClass('is-visible').attr('aria-hidden', 'true');
            $navPanelOverlay.removeClass('is-visible');
            $navItems.removeClass('is-active').find('.nav-link').attr('aria-expanded', 'false');
            $navPanels.removeClass('is-active');
            $navPanelBackLabel.text('');
        };

        closeNavPanelsFn = closeNavPanelImmediately;

        $navItems.find('.nav-link').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $item = $(this).closest('.nav-item');
            const isCurrentlyOpen = $navPanelCont.hasClass('is-visible') && $item.hasClass('is-active');

            if (isCurrentlyOpen) {
                closeNavPanelImmediately();
            } else {
                showNavPanel($item.data('navPanel'), $item);
            }
        });

        $navPanelOverlay.on('click', closeNavPanelImmediately);

        $navPanelBack.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            closeNavPanelImmediately();
        });

        $navPanelBack.on('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeNavPanelImmediately();
            }
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('#siteNavBar, #navPanelContainer').length) {
                closeNavPanelImmediately();
            }
        });

        $(document).on('keydown', (e) => {
            if (e.key === 'Escape') closeNavPanelImmediately();
        });

        $(window).on('resize', () => {
            if ($navPanelCont.hasClass('is-visible')) {
                positionNavPanel($navItems.filter('.is-active'));
            }
        });
    }

    // --- Mega Menu (two-pane department browser — triggered by the
    // "Categories" nav-bar link; it used to be the "All Departments"
    // button's menu, swapped so that button now opens the flat
    // All-Departments panel below instead). ---
    const $categoriesNavItem = $('#categoriesNavItem');
    const $megaMenu = $('#megaMenu');
    const $overlay = $('#megaMenuOverlay');
    const $deptItems = $('.mega-menu__dept-item');
    const $panels = $('.mega-menu__panel');
    const $megaMenuBack = $('#megaMenuBack');
    const $megaMenuBackLabel = $('#megaMenuBackLabel');

    if ($categoriesNavItem.length && $megaMenu.length && $overlay.length) {
        const $categoriesLink = $categoriesNavItem.find('.nav-link');

        const positionMenu = () => {
            const $header = $('.site-header');
            if ($header.length) {
                const headerBottom = $header[0].getBoundingClientRect().bottom;
                const navBarBottom = (!mobileNavQuery.matches && $navBar.length && $navBar.is(':visible'))
                    ? $navBar[0].getBoundingClientRect().bottom
                    : 0;
                const topPos = Math.max(headerBottom, navBarBottom);
                $megaMenu.css('top', topPos + 'px');
                $overlay.css('top', topPos + 'px');
            }
        };

        const openMenu = () => {
            if (typeof closeNavPanelsFn === 'function') closeNavPanelsFn();
            if (typeof closeAllDeptFn === 'function') closeAllDeptFn();

            positionMenu();
            $megaMenu.addClass('is-visible').attr('aria-hidden', 'false');
            $overlay.addClass('is-visible');
            $categoriesNavItem.addClass('is-active');
            $categoriesLink.attr('aria-expanded', 'true');
        };

        const closeMenu = () => {
            $megaMenu.removeClass('is-visible').attr('aria-hidden', 'true');
            $overlay.removeClass('is-visible');
            $categoriesNavItem.removeClass('is-active');
            $categoriesLink.attr('aria-expanded', 'false');
            // Reset the mobile drill-down so the menu always reopens on the
            // department list, not wherever the visitor last drilled into.
            $megaMenu.removeClass('is-mobile-drilled');
            $megaMenuBackLabel.text('');
        };

        closeMegaMenuFn = closeMenu;

        $categoriesLink.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $megaMenu.hasClass('is-visible') ? closeMenu() : openMenu();
        });

        $overlay.on('click', closeMenu);

        $(document).on('keydown', (e) => {
            if (e.key === 'Escape') closeMenu();
        });

        $deptItems.on('mouseenter click', function () {
            const $item = $(this);
            const panelId = $item.attr('data-panel');

            $deptItems.removeClass('is-active');
            $item.addClass('is-active');

            $panels.removeClass('is-active');
            $('#' + panelId).addClass('is-active');

            // On mobile the left department list and right subcategory panel
            // aren't shown side by side (no room at 360px) — drilling into a
            // department instead swaps to a full-screen subcategory view,
            // with the back bar's label naming the department the visitor
            // is currently inside. Harmless on desktop: the CSS that reacts
            // to is-mobile-drilled only applies under the mobile breakpoint.
            $megaMenu.addClass('is-mobile-drilled');
            $megaMenuBackLabel.text($item.find('.mega-menu__dept-name').text());
        });

        $deptItems.on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('mouseenter');
            }
        });

        $megaMenuBack.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if ($megaMenu.hasClass('is-mobile-drilled')) {
                // Subcategory view -> back to the department list.
                $megaMenu.removeClass('is-mobile-drilled');
                $megaMenuBackLabel.text('');
            } else {
                // Department list is the top level -> close the whole menu.
                closeMenu();
            }
        });

        $megaMenuBack.on('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $megaMenuBack.trigger('click');
            }
        });

        $megaMenu.on('click', (e) => {
            e.stopPropagation();
        });

        $(window).on('resize scroll', () => {
            if ($megaMenu.hasClass('is-visible')) positionMenu();
        });
    }

    // --- All Departments Panel (flat grid — now triggered by the
    // "All Departments" button next to the search bar). ---
    const $catBtn = $('#categoryDropdownBtn');
    const $allDeptPanel = $('#allDepartmentsPanel');
    const $allDeptOverlay = $('#allDepartmentsOverlay');

    if ($catBtn.length && $allDeptPanel.length && $allDeptOverlay.length) {
        const positionAllDept = () => {
            const $header = $('.site-header');
            if ($header.length) {
                const headerBottom = $header[0].getBoundingClientRect().bottom;
                $allDeptPanel.css('top', headerBottom + 'px');
                $allDeptOverlay.css('top', headerBottom + 'px');
            }
        };

        const openAllDept = () => {
            if (typeof closeNavPanelsFn === 'function') closeNavPanelsFn();
            if (typeof closeMegaMenuFn === 'function') closeMegaMenuFn();

            positionAllDept();
            $allDeptPanel.addClass('is-visible').attr('aria-hidden', 'false');
            $allDeptOverlay.addClass('is-visible');
            $catBtn.addClass('is-open').attr('aria-expanded', 'true');
        };

        const closeAllDept = () => {
            $allDeptPanel.removeClass('is-visible').attr('aria-hidden', 'true');
            $allDeptOverlay.removeClass('is-visible');
            $catBtn.removeClass('is-open').attr('aria-expanded', 'false');
        };

        closeAllDeptFn = closeAllDept;

        $catBtn.on('click', (e) => {
            e.stopPropagation();
            $allDeptPanel.hasClass('is-visible') ? closeAllDept() : openAllDept();
        });

        $allDeptOverlay.on('click', closeAllDept);

        $(document).on('keydown', (e) => {
            if (e.key === 'Escape') closeAllDept();
        });

        $allDeptPanel.on('click', (e) => {
            e.stopPropagation();
        });

        $(window).on('resize scroll', () => {
            if ($allDeptPanel.hasClass('is-visible')) positionAllDept();
        });
    }

    // -------------------------------------------------------------------------
    // 9. Mobile Hamburger Menu Toggle
    // -------------------------------------------------------------------------
    const $mobileMenuBtn = $('#mobileMenuBtn');
    const $siteNavBar = $('#siteNavBar');

    if ($mobileMenuBtn.length && $siteNavBar.length) {
        // On mobile the drawer is a fixed overlay (so opening it can't push
        // the page's own content down) positioned right below the header,
        // same as the mega-menu/nav-panel/all-departments panels — it needs
        // its own top set from JS for the same reason those do.
        const positionSiteNavBar = () => {
            const $header = $('.site-header');
            if ($header.length) {
                $siteNavBar.css('top', $header[0].getBoundingClientRect().bottom + 'px');
            }
        };

        // Hide nav bar on mobile by default (CSS handles initial state via responsive.css)
        // We use a class to toggle visibility smoothly
        $mobileMenuBtn.on('click', function () {
            const isOpen = $mobileMenuBtn.hasClass('is-open');

            if (!isOpen) {
                positionSiteNavBar();
                // Consistent with how those three panels already close each
                // other — a stray "All Departments" or "Categories" panel
                // left open behind the drawer would otherwise stack fixed
                // overlays on top of each other.
                if (typeof closeMegaMenuFn === 'function') closeMegaMenuFn();
                if (typeof closeNavPanelsFn === 'function') closeNavPanelsFn();
                if (typeof closeAllDeptFn === 'function') closeAllDeptFn();
            }

            $mobileMenuBtn.toggleClass('is-open');
            $mobileMenuBtn.attr('aria-expanded', !isOpen).attr('aria-label', isOpen ? 'Open navigation menu' : 'Close navigation menu');
            $siteNavBar.toggleClass('is-mobile-open');
        });

        $(window).on('resize scroll', () => {
            if ($siteNavBar.hasClass('is-mobile-open')) positionSiteNavBar();
        });

        // A keyboard user can dismiss the mobile navigation without traversing the whole menu.
        $(document).on('keydown', function (event) {
            if (event.key === 'Escape' && $siteNavBar.hasClass('is-mobile-open')) {
                $mobileMenuBtn.removeClass('is-open').attr('aria-expanded', 'false').attr('aria-label', 'Open navigation menu');
                $siteNavBar.removeClass('is-mobile-open');
                $mobileMenuBtn[0].focus();
            }
        });

        // Close nav on resize back to desktop
        $(window).on('resize', function () {
            if (window.innerWidth > 768) {
                $mobileMenuBtn.removeClass('is-open').attr('aria-expanded', 'false').attr('aria-label', 'Open navigation menu');
                $siteNavBar.removeClass('is-mobile-open');
            }
        });
    }
});



/* Product-card variant delegation: one shared copy, including AJAX-inserted cards. */

  // Guarded so this only wires up once even though this snippet — and the
  // script tag with it — gets rendered once per product card on the page.
  if (!window.__scProductCardSwatchesInit) {
    window.__scProductCardSwatchesInit = true;

    (function () {
      function getVariantsData(card) {
        if (card.__scVariantsData) return card.__scVariantsData;

        var script = card.querySelector('.product-card-variants-json');
        var variants = [];
        if (script) {
          try {
            variants = JSON.parse(script.textContent);
          } catch (e) {
            variants = [];
          }
        }

        var selected = [];
        try {
          selected = JSON.parse(card.getAttribute('data-initial-options') || '[]');
        } catch (e) {
          selected = [];
        }

        card.__scVariantsData = { variants: variants, selected: selected };
        return card.__scVariantsData;
      }

      function findVariant(variants, selected) {
        return variants.filter(function (variant) {
          return selected.every(function (value, index) {
            return value == null || variant.options[index] === value;
          });
        })[0];
      }

      function formatMoney(cents) {
        var parts = (cents / 100).toFixed(2).split('.');
        return ((window.theme && window.theme.settings.currency_symbol) || '$') + parts[0] + '<sup>' + parts[1] + '</sup>';
      }

      function applyVariant(card, variant) {
        if (!variant) return;
        card.__scMatchedVariant = variant;

        var img = card.querySelector('.product-img-wrap img');
        if (img) {
          var src = (variant.featured_image && variant.featured_image.src) || card.getAttribute('data-default-image');
          if (src) img.src = src;
        }

        var suffix = card.querySelector('.product-title .product-title-variant-suffix');
        if (suffix) suffix.textContent = variant.options.join(' ');

        var pricing = card.querySelector('.product-pricing');
        var priceMain = card.querySelector('.product-pricing .price-main');
        if (priceMain) priceMain.innerHTML = formatMoney(variant.price);
        if (pricing) {
          var priceWas = pricing.querySelector('.price-was');
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            if (!priceWas) {
              priceWas = document.createElement('span');
              priceWas.className = 'price-was';
              pricing.appendChild(priceWas);
            }
            priceWas.innerHTML = formatMoney(variant.compare_at_price);
            priceWas.style.display = '';
            pricing.classList.add('product-pricing--sale');
          } else if (priceWas) {
            priceWas.style.display = 'none';
            pricing.classList.remove('product-pricing--sale');
          }
        }

        var btn = card.querySelector('.product-card-ajax-add, .add-to-cart-trigger');
        if (btn) {
          btn.setAttribute('data-id', variant.id);
          btn.setAttribute('data-product-id', variant.id);
          btn.setAttribute('data-price', (variant.price / 100).toFixed(2));
          if (variant.featured_image && variant.featured_image.src) {
            btn.setAttribute('data-image', variant.featured_image.src);
          }
          var label = btn.querySelector('span');
          if (variant.available) {
            btn.removeAttribute('disabled');
            if (label) label.textContent = 'Add to Cart';
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (label) label.textContent = 'Sold Out';
          }
        }

        var stockAlert = card.querySelector('.product-card-stock-alert');
        if (stockAlert) {
          stockAlert.hidden = !!variant.available;
          var alertUrl = new URL(stockAlert.href, location.origin);
          alertUrl.searchParams.set('variant', variant.id);
          stockAlert.href = alertUrl.href;
        }

        // Every swatch/size link in this card is a real <a> that already
        // points at a variant matching just its own value (rendered by
        // Liquid, works with no JS at all). Once both dimensions are known,
        // upgrade every link so a click lands on the exact combination —
        // not just the one dimension that link represents on its own.
        var baseUrl = card.getAttribute('data-product-url');
        if (baseUrl) {
          card.querySelectorAll('.product-swatches .swatch-dot, .product-sizes .size-item').forEach(function (link) {
            link.setAttribute('href', baseUrl + '?variant=' + variant.id);
          });
        }
      }

      function selectOption(el) {
        var card = el.closest('.product-card');
        var group = el.closest('[data-option-index]');
        if (!card || !group) return;

        var index = parseInt(group.getAttribute('data-option-index'), 10);
        if (isNaN(index)) return;

        group.querySelectorAll('.active').forEach(function (node) {
          node.classList.remove('active');
        });
        el.classList.add('active');

        var data = getVariantsData(card);
        data.selected[index] = el.getAttribute('data-value');

        applyVariant(card, findVariant(data.variants, data.selected));
      }

      // Hovering a swatch/size previews (and effectively selects) that
      // option, same as clicking it would on the product page.
      document.addEventListener('mouseover', function (e) {
        var target = e.target.closest('.product-swatches .swatch-dot, .product-sizes .size-item');
        if (target) selectOption(target);
      });

      // Each swatch/size is a real <a href> (see product-card.liquid) that
      // already points at a matching variant, so clicking navigates on its
      // own even if JS never runs. This just makes sure THIS click's own
      // value is applied — and every link's href updated to the fuller
      // match — before the browser follows it, in case no prior hover
      // (e.g. touch) already did that.
      document.addEventListener('click', function (e) {
        var target = e.target.closest('.product-swatches .swatch-dot, .product-sizes .size-item');
        if (target) selectOption(target);
      });
    })();
  }

